import React, { useContext } from 'react';
import { IDetailData } from '../detail-data';
import { Col, Label, Panel } from 'react-bootstrap';
import { PanelBodyWrapper, ReadOnlyField } from '../styles';
import { useFormContext } from 'react-hook-form';
import WorkflowActionsDropdown from '../workflow-actions-dropdown';
import { PatientIntakeContext } from '../context';

const RegistrationDetails = () => {
    const { watch } = useFormContext<IDetailData>();

    const data = watch();

    return (
        <Panel>
            <Panel.Heading>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>Registration Details</div>
                    <div>
                        <WorkflowActionsDropdown
                            hasAboResults={data != null ? data.hasAboResults : false}
                            hasPendingPreWorkupLabs={(data as any)?.hasPendingPreWorkupLabs || false}
                            medicalRecordId={data != null ? data.medicalRecordId : 0}
                            patientScreenId={data != null ? data.patientScreenId : 0}
                            firstName={data != null ? data.firstName : ''}
                            lastName={data != null ? data.lastName : ''}
                            allowTransfer={data != null ? data.patientScreenChoiceId > 0 : false}
                            isList={false}
                        />
                    </div>
                </div>
            </Panel.Heading>
            <PanelBodyWrapper>
                <ReadOnlyField>
                    <Col xs={12} lg={4}>
                        <label>Medical Record ID:</label>
                    </Col>
                    <Col xs={12} lg={8} className='field-value'>{data.medicalRecordId}</Col>
                </ReadOnlyField>
                <ReadOnlyField>
                    <Col xs={12} lg={4}>
                        <label>Source:</label>
                    </Col>
                    <Col xs={12} lg={8} className='field-value'>
                        <Label bsStyle={data.source ? 'primary' : 'default'}>
                            {data.source || 'N/A'}
                        </Label>
                    </Col>
                </ReadOnlyField>
                <ReadOnlyField>
                    <Col xs={12} lg={4}>
                        <label>Registration Date:</label>
                    </Col>
                    <Col xs={12} lg={8} className='field-value'>{data.registrationDate}</Col>
                </ReadOnlyField>
                <ReadOnlyField>
                    <Col xs={12} lg={4}>
                        <label>Registration Status:</label>
                    </Col>
                    <Col xs={12} lg={8} className='field-value'>{data.registrationStatus} {data.registrationStatusId == 40 ? <>({data.centerName})</> : null}</Col>
                </ReadOnlyField>
                {/* <ReadOnlyField>
                    <Col xs={12} lg={4}>
                        <label>Center:</label>
                    </Col>
                    <Col xs={12} lg={8} className='field-value'>{data.centerName}</Col>
                </ReadOnlyField> */}
            </PanelBodyWrapper>
        </Panel>
    );
}

export default RegistrationDetails;